export default __webpack_public_path__ + "property.3bd3b0c7939871b3299977be1a571b07.png";